import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './shared/guards/auth.guard'

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    // canActivate: [AuthGuard],
  },
  {
    path: 'bracelet-printer',
    loadComponent: () =>
      import('./bracelet-printer/bracelet-printer.component').then((c) => c.BraceletPrinterComponent),
    canActivate: [AuthGuard],
  },
  {
    path: '*',
    pathMatch: 'full',
    redirectTo: 'login',
  },
]

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
